import { atom } from 'jotai';
import { routesAtom } from '../Atoms';
import { flattenRoutes } from './routes';

/**
 * Every renderable leaf of the server route tree, flattened once.
 *
 * Derived rather than computed per component: the tree walk was previously run
 * unmemoized in the navbar, the outlet, the default-page dialog and on every
 * `useLocationName` call, so it repeated many times per render. A derived atom
 * recomputes only when `routesAtom` changes and shares the result.
 *
 * Lives here rather than in `src/Atoms` to avoid a cycle: `Router/routes.js`
 * imports every page component, and pages import `src/Atoms`.
 */
export const flatRoutesAtom = atom((get) => flattenRoutes(get(routesAtom)));
